// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"524":"Product","770":"Partners","848":"Register","922":"MyAccount"}[chunkId] + "." + {"524":"11c09926","770":"d60f2a77","848":"0e9bb416","922":"f79829e4"}[chunkId] + ".css";
};